import { render, staticRenderFns } from "./DocumentSignatureHistory.vue?vue&type=template&id=0d42b741&scoped=true&"
import script from "./DocumentSignatureHistory.vue?vue&type=script&lang=js&"
export * from "./DocumentSignatureHistory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSignatureHistory.vue?vue&type=style&index=0&id=0d42b741&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42b741",
  null
  
)

export default component.exports